export const ALL_FILTER_OPTION_VALUE = '__all__'

export type FilterSelectValue<T extends string | number> =
    | T
    | typeof ALL_FILTER_OPTION_VALUE

export interface FilterOption<T extends string | number> {
    label: string
    value: T
    disabled?: boolean
    title?: string
}

export const buildAllFilterOptions = <T extends string | number>(
    allLabel: string,
    options: FilterOption<T>[]
): FilterOption<FilterSelectValue<T>>[] => [
    {
        label: allLabel,
        value: ALL_FILTER_OPTION_VALUE,
    },
    ...options,
]

export const getAllAwareDisplayValues = <T extends string | number>(
    values: T[]
): FilterSelectValue<T>[] =>
    values.length === 0 ? [ALL_FILTER_OPTION_VALUE] : values

export const normalizeAllAwareValues = <T extends string | number>(
    rawValues: FilterSelectValue<T>[],
    previousValues: T[]
): T[] => {
    if (!rawValues.includes(ALL_FILTER_OPTION_VALUE)) {
        return rawValues as T[]
    }

    const concreteValues = rawValues.filter(
        (value): value is T => value !== ALL_FILTER_OPTION_VALUE
    )

    if (previousValues.length === 0) {
        return concreteValues
    }

    return []
}
